import {Redirect, Route, Switch} from 'react-router-dom';
import ISScene from './ISScene';
import Urls from '../../constants/urls';
import { 
    entranceHotspots,
    entranceDisplayHotspots,
    exitDisplayHotspots,
    centerHotspots,
    hayBalesHotspots,
    exitHotspots,
    cornerHotspots,
    stairsHotspots,
    upstairsEntranceHotspots,
    upstairsCenterHotspots,
    upstairsDisplayHotspots,
    outsideCenterHotspots,
    outsideEntranceHotspots,
    outsideLeftHotspots,
    outsideRightHotspots
} from './data';

const ISRooms = () => {
    return (
      <Switch>
        <Route 
          {...Urls.ivyShop.root}
          render={() => <Redirect to={Urls.ivyShop.outsideCenter.path} />}  
        />
        <Route {...Urls.ivyShop.entrance}>
            <ISScene
                id="ivyshop-entrance"
                yRotation={270}
                hotspots={entranceHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.entranceDisplay}>
            <ISScene
                id="ivyshop-entrance-display"
                yRotation={270}
                hotspots={entranceDisplayHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.exitDisplay}>
            <ISScene
                id="ivyshop-exit-display"
                yRotation={270}
                hotspots={exitDisplayHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.center}>
            <ISScene
                id="ivyshop-center"
                yRotation={270}
                hotspots={centerHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.hayBales}>
            <ISScene
                id="ivyshop-hay-bales"
                yRotation={270}
                hotspots={hayBalesHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.exit}>
            <ISScene
                id="ivyshop-exit"
                yRotation={90}
                hotspots={exitHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.corner}>
            <ISScene
                id="ivyshop-corner"
                yRotation={270}
                hotspots={cornerHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.stairs}>
            <ISScene
                id="ivyshop-stairs"
                yRotation={270}
                hotspots={stairsHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.upstairsEntrance}>
            <ISScene
                id="ivyshop-upstairs-entrance"
                yRotation={270}
                hotspots={upstairsEntranceHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.upstairsCenter}>
            <ISScene
                id="ivyshop-upstairs-center"
                yRotation={270}
                hotspots={upstairsCenterHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.upstairsDisplay}>
            <ISScene
                id="ivyshop-upstairs-display"
                yRotation={270}
                hotspots={upstairsDisplayHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.outsideCenter}>
            <ISScene
                id="ivyshop-outside-center"
                yRotation={270}
                hotspots={outsideCenterHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.outsideEntrance}>
            <ISScene
                id="ivyshop-outside-entrance"
                yRotation={270}
                hotspots={outsideEntranceHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.outsideLeft}>
            <ISScene
                id="ivyshop-outside-left"
                yRotation={270}
                hotspots={outsideLeftHotspots}
            />
        </Route>
        <Route {...Urls.ivyShop.outsideRight}>
            <ISScene
                id="ivyshop-outside-right"
                yRotation={270}
                hotspots={outsideRightHotspots}
            />
        </Route>
      </Switch>
    );
  };
  
  export default ISRooms;
